import React from "react";
// Components
import Button, { ButtonOnClickType } from "@vahak/core-ui/dist/components/Button";
// Constants
import { UserScreenId } from "@vahak/core/dist/constants/userScreenId";
import { AssuredLoadEvents } from "@vahak/core/dist/constants/event-names";
import { useCsDashboard } from "@vahak/core/dist/hooks/useCsDashboard";

// Methods
import { getPriceString } from "@vahak/core-ui/dist/methods/common";
// Hooks
import { useRouter } from "next/router";
import { IPaymentContextData, usePayment } from "../../../../../context/payment-context";
import { BookingAmountOrderRequest } from "../../../../../services/vas/useGeneratePayment";
// Assets
import PriceIcon from "@vahak/core/dist/standard-icons/payment-coin.svg";
import Styles from "./PaymentBtn.module.scss";
import { IEventTrackerProp } from "../../../../../types/events";

interface PaymentBtnProps {
    bookingAmount?: number;
    closeBidForm?: () => void;
    bookingData?: BookingAmountOrderRequest;
    redirection?: () => void;
    paymentType: IPaymentContextData["type"];
    trackEvent: IEventTrackerProp["trackEvent"];
}

const PaymentBtn = ({
    bookingAmount,
    closeBidForm,
    bookingData,
    redirection,
    paymentType,
    trackEvent
}: PaymentBtnProps) => {
    const { isCsDashboardUser } = useCsDashboard();
    const { updatePaymentData } = usePayment();
    const router = useRouter();
    const currentPath = router.asPath;
    const redirectToCurrentPage = () => {
        router.replace(currentPath, undefined, {
            shallow: true
        });
    };

    const handleRedirection = redirection || redirectToCurrentPage;

    const onAction: ButtonOnClickType = (e) => {
        e.stopPropagation();
        closeBidForm?.();

        updatePaymentData?.({
            type: paymentType,
            allowCoinUse: true,
            bidBookingInfo: bookingData,
            onClickBack: handleRedirection,
            postFailure: handleRedirection,
            postSuccess: handleRedirection,
            onSuccess: () => {
                trackEvent?.(AssuredLoadEvents["payment_success"]);
            }
        });

        trackEvent?.(AssuredLoadEvents["payment_pay_now_btn"]);

        router?.push(UserScreenId.payment.pathname, undefined, {
            shallow: true
        });
    };
    return (
        <span className={Styles.main}>
            <Button
                data-assured-payment-btn
                onClick={onAction}
                disabled={!bookingData?.bid_id || isCsDashboardUser}
                startIcon={
                    <>
                        <PriceIcon />
                        Pay {getPriceString(bookingAmount)}
                    </>
                }
            >
                {null}
            </Button>
        </span>
    );
};

export default PaymentBtn;
